import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSignUp$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSignUp extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ce6bd64c4a964c3c46b21dd577e49c91329bf790', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '16d5d134fae1b0329656ba9579bcb55ea892ff64', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd4a6ae05acd263e2a4c1f6a50b371ebb013ec32d', d: "M18.486 10.536a.52.52 0 0 1 .143-.395l.502-.515c.276-.283.75-.147.799.246Q20 10.427 20 11a9 9 0 1 1-7.387-8.856c.374.068.498.52.233.792l-.462.474a.52.52 0 0 1-.438.149 7.5 7.5 0 1 0 6.54 6.977m1.425-6.081c.136-.136.114-.379-.049-.542l-1.768-1.774c-.163-.164-.405-.186-.54-.05l-1.228 1.232 2.357 2.366z", fill: "currentColor" }), h("path", { key: 'acd4076bcbb17ed1f4517ae5d62d81c22a73b6d4', d: "m15.441 4.209-6.483 6.505-.935 2.731a.418.418 0 0 0 .523.534l2.77-.899 6.483-6.506z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-sign-up", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-sign-up"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-sign-up":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSignUp$1);
            }
            break;
    } });
}

const CosmosIconSignUp = CosmosIconSignUp$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSignUp, defineCustomElement };
